export const LETTER_TYPES = [
  "aor_confirmation_request",
  "appeal_acknowledgement",
  "attachment",
  "determination_letter",
  "dismissal_notice",
  "extension_letter",
  "external_appeal_confirmation",
  "external_questionnaire",
  "facility_outreach",
  "fax_coversheet",
  "ineligible_fax_notification",
  "ire_case_status",
  "medicaid_enrollment_notification",
  "missing_information",
  "other",
  "outreach_case_initiation",
  "pharmacy_outreach",
  "post_review_discussion_notification",
  "pre_denial_notification",
  "supporting_statement_request",
] as const;

export type LetterType = (typeof LETTER_TYPES)[number];

export const PLAN_APPEAL_REVIEW_LEVELS = [
  "appeals_first_level",
  "appeals_second_level",
] as const;

export type AppealReviewLevels = typeof PLAN_APPEAL_REVIEW_LEVELS[number]

export const SUPPORTED_LETTER_TEMPLATE_LANGUAGES = ["es", "zh", "en"] as const;
export type SupportedLetterLanguages = typeof SUPPORTED_LETTER_TEMPLATE_LANGUAGES[number];

export const SUPPORTED_LETTER_TEMPLATE_FORMATS = ["large_print"] as const;
export type SupportedLetterFormats = typeof SUPPORTED_LETTER_TEMPLATE_FORMATS[number];

export const FORMAT_LABELS: Record<SupportedLetterFormats, string> = {
  large_print: "Large Print",
};

export const FundingTypes = {
  fully_insured: "Fully-insured",
  self_insured: "Self-insured",
};

export const LETTER_TEMPLATE_CASE_OUTCOMES = ["approved", "denied", "partial_decision"] as const;
export type LetterTemplateCaseOutcome = typeof LETTER_TEMPLATE_CASE_OUTCOMES[number];
